let itemsMenu = [
    {
		"category": "Menu",
		"name": "Couscous Royal",
		"date": "Samedi 6 et Dimanche 7 mai",
		"slot": "16 places",
		"reservationEnd": "Mardi 2 mai",
		"price": "25,00",
		"entree": "Assortiment de salades marocaines",
		"plat": "Couscous Royal (Merguez, poulet et agneau)",
		"dessert": "Pâtisseries marocaines",
	},
	{
		"category": "Menu",
		"name": "Tajine Mukfoul",
		"date": "Samedi 13 et Dimanche 14 mai",
		"slot": "16 places",
		"reservationEnd": "Mardi 9 mai",
		"price": "20,00",
		"entree": "Assortiment de salades marocaines",
		"plat": "Tajine Makfoul (Agneau, sucré-salé)",
		"dessert": "Pâtisseries marocaines",
	},
	{
		"category": "Menu",
		"name": "Tajine de poulet",
		"date": "Samedi 20 et Dimanche 21 mai",
		"slot": "16 places ou à emporter",
		"reservationEnd": "Mardi 16 mai",
		"price": "20,00",
		"entree": "Assortiment de salades marocaines",
		"plat": "Tajine de poulet au citron confit",
		"dessert": "Pâtisseries marocaines",
	},
	{
		"category": "Menu",
		"name": "Pastilla au poulet",
		"date": "Samedi 27 et Dimanche 28 mai",
		"slot": "16 places ou à emporter",
		"reservationEnd": "Mardi 23 mai",
		"price": "20,00",
		"entree": "Assortiment de salades marocaines",
		"plat": "Pastilla au poulet (sucré-salé)",
		"dessert": "",
	},
  ]

  export default itemsMenu;